// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"752f27e2","80":"8cbbba12","97":"8b6e4d67","147":"5b0d5eb4","362":"33779cfc","604":"56571bfe","807":"a97a717f","818":"dfdd2819","899":"af823aba","900":"a762918c","996":"8223eb66"}[chunkId] + ".chunk.js";
};